'use strict';

module.exports = {
  apply: require('./apply'),
  complement: require('./complement'),
  compose: require('./compose'),
  enforceTypes: require('./enforceTypes'),
  identity: require('./identity'),
  ifn: require('./ifn'),
  memoize: require('./memoize'),
  overload: require('./overload'),
  partial: require('./partial'),
  partialReverse: require('./partialReverse'),
  silent: require('./silent'),
  thread: require('./thread'),
  through: require('./through'),
  truncateArgs: require('./truncateArgs')
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/functional/index.js
// module id = 2170
// module chunks = 37